function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_Calendar_1209677",
  transform: "translate(-15.9 -7.9)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M17.137,15.339h.339a.17.17,0,0,0,0-.339h-.339A1.137,1.137,0,0,0,16,16.137v9.6a1.137,1.137,0,0,0,1.137,1.137h9.6a1.137,1.137,0,0,0,1.137-1.137v-9.6A1.137,1.137,0,0,0,26.741,15h-.39a.17.17,0,1,0,0,.339h.39a.8.8,0,0,1,.8.8v2.087h-11.2V16.137A.8.8,0,0,1,17.137,15.339Zm10.4,3.224v7.178a.8.8,0,0,1-.8.8h-9.6a.8.8,0,0,1-.8-.8V18.563Z",
  transform: "translate(0 -5.812)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_53",
  "data-name": "Path 53",
  d: "M38.3,15.17a.16.16,0,0,0,.17.17h3.954a.17.17,0,1,0,0-.339H38.47A.17.17,0,0,0,38.3,15.17Z",
  transform: "translate(-18.516 -5.812)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_54",
  "data-name": "Path 54",
  d: "M26.509,45.867h.848a.5.5,0,0,0,.509-.509v-.848A.5.5,0,0,0,27.357,44h-.848a.5.5,0,0,0-.509.509v.848A.5.5,0,0,0,26.509,45.867Zm-.17-1.357a.16.16,0,0,1,.17-.17h.848a.16.16,0,0,1,.17.17v.848a.16.16,0,0,1-.17.17h-.848a.16.16,0,0,1-.17-.17Z",
  transform: "translate(-8.303 -29.891)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M45.509,45.867h.848a.5.5,0,0,0,.509-.509v-.848A.5.5,0,0,0,46.357,44h-.848a.5.5,0,0,0-.509.509v.848A.5.5,0,0,0,45.509,45.867Zm-.17-1.357a.16.16,0,0,1,.17-.17h.848a.16.16,0,0,1,.17.17v.848a.16.16,0,0,1-.17.17h-.848a.16.16,0,0,1-.17-.17Z",
  transform: "translate(-24.079 -29.891)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M64.509,45.867h.848a.5.5,0,0,0,.509-.509v-.848A.5.5,0,0,0,65.357,44h-.848a.5.5,0,0,0-.509.509v.848A.5.5,0,0,0,64.509,45.867Zm-.17-1.357a.16.16,0,0,1,.17-.17h.848a.16.16,0,0,1,.17.17v.848a.16.16,0,0,1-.17.17h-.848a.16.16,0,0,1-.17-.17Z",
  transform: "translate(-39.855 -29.891)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M26.509,64.867h.848a.5.5,0,0,0,.509-.509v-.848A.5.5,0,0,0,27.357,63h-.848a.5.5,0,0,0-.509.509v.848A.5.5,0,0,0,26.509,64.867Zm-.17-1.357a.16.16,0,0,1,.17-.17h.848a.16.16,0,0,1,.17.17v.848a.16.16,0,0,1-.17.17h-.848a.16.16,0,0,1-.17-.17Z",
  transform: "translate(-8.303 -45.667)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M45.509,64.867h.848a.5.5,0,0,0,.509-.509v-.848A.5.5,0,0,0,46.357,63h-.848a.5.5,0,0,0-.509.509v.848A.5.5,0,0,0,45.509,64.867Zm-.17-1.357a.16.16,0,0,1,.17-.17h.848a.16.16,0,0,1,.17.17v.848a.16.16,0,0,1-.17.17h-.848a.16.16,0,0,1-.17-.17Z",
  transform: "translate(-24.079 -45.667)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_59",
  "data-name": "Path 59",
  d: "M64.509,64.867h.848a.5.5,0,0,0,.509-.509v-.848A.5.5,0,0,0,65.357,63h-.848a.5.5,0,0,0-.509.509v.848A.5.5,0,0,0,64.509,64.867Zm-.17-1.357a.16.16,0,0,1,.17-.17h.848a.16.16,0,0,1,.17.17v.848a.16.16,0,0,1-.17.17h-.848a.16.16,0,0,1-.17-.17Z",
  transform: "translate(-39.855 -45.667)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60",
  "data-name": "Path 60",
  d: "M66,8.509v1.7a.5.5,0,0,0,.509.509h.339a.5.5,0,0,0,.509-.509v-1.7A.5.5,0,0,0,66.848,8h-.339A.5.5,0,0,0,66,8.509Zm1.018,0v1.7a.16.16,0,0,1-.17.17h-.339a.16.16,0,0,1-.17-.17v-1.7a.16.16,0,0,1,.17-.17h.339A.16.16,0,0,1,67.018,8.509Z",
  transform: "translate(-41.516)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_61",
  "data-name": "Path 61",
  d: "M28.848,10.715a.5.5,0,0,0,.509-.509v-1.7A.5.5,0,0,0,28.848,8h-.339A.5.5,0,0,0,28,8.509v1.7a.5.5,0,0,0,.509.509Zm-.509-.509v-1.7a.16.16,0,0,1,.17-.17h.339a.16.16,0,0,1,.17.17v1.7a.16.16,0,0,1-.17.17h-.339A.16.16,0,0,1,28.339,10.206Z",
  transform: "translate(-9.964)",
  fill: "#b9b9b9",
  stroke: "#b9b9b9",
  strokeWidth: 0.2
}));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.078,
    height: 13.266,
    viewBox: "0 0 12.078 13.266",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Calendar.1fb8f1a3.svg";
export { ForwardRef as ReactComponent };